module.exports = __webpack_public_path__ + "img/Silver.1883c665.png";